import { Star } from 'lucide-react';
import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import FilterMenu from '@/components/ui/filter-menu';
import useSearchParamActions from '@/customHooks/useSearchParamActions';

const RATING_FILTERS = [
  { value: '1', label: '1+ Stars' },
  { value: '2', label: '2+ Stars' },
  { value: '3', label: '3+ Stars' },
  { value: '4', label: '4+ Stars' },
  { value: '5', label: '5 Stars' },
];

function RatingFilter({ submenu }: { submenu?: boolean }) {
  const { appendSearchParam, removeSearchParam } = useSearchParamActions();

  return (
    <FilterMenu
      submenu={submenu}
      label={
        <>
          <Star className="h-4 w-4" />
          Rating
        </>
      }
    >
      <DropdownMenuItem onClick={() => removeSearchParam('ratings')}>
        All Ratings
      </DropdownMenuItem>
      {RATING_FILTERS.map((rating) => (
        <DropdownMenuItem
          key={rating.value}
          onClick={() => appendSearchParam('ratings', rating.value)}
        >
          {rating.label}
        </DropdownMenuItem>
      ))}
    </FilterMenu>
  );
}

export default RatingFilter;
